import types from "./types";

const initialState = {
  oblpListing: {},
  nonOblpListing: {},
  myOblpListing: {},
  myNonOblpListing: {},
  globalSearchLP: {},
  lpsIncludedWithSubscription: {},
  surveyListing:{},
  showSurveyListing:{},
  submitSurveyListing:{},
  templateListing:{}
};

const lp = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_OBLP_LISTING_RESP:
      return {
        ...state,
        oblpListing: action.payload,
      };
    case types.GET_OBLP_LISTING_CLEAR:
      return {
        ...state,
        oblpListing: {},
      };
    case types.GET_NON_OBLP_LISTING_RESP:
      return {
        ...state,
        nonOblpListing: action.payload,
      };
    case types.GET_NON_OBLP_LISTING_CLEAR:
      return {
        ...state,
        nonOblpListing: {},
      };
    case types.GET_MY_OBLP_LISTING_RESP:
      return {
        ...state,
        myOblpListing: action.payload,
      };
    case types.GET_MY_OBLP_LISTING_CLEAR:
      return {
        ...state,
        myOblpListing: {},
      };
    case types.GET_NON_MY_OBLP_LISTING_RESP:
      return {
        ...state,
        myNonOblpListing: action.payload,
      };
    case types.GET_NON_MY_OBLP_LISTING_CLEAR:
      return {
        ...state,
        myNonOblpListing: {},
      };
    case types.GLOBAL_SEARCH_LP_RESPONSE:
      return {
        ...state,
        globalSearchLP: action.payload,
      };
    case types.GLOBAL_SEARCH_LP_CLEAR:
      return {
        ...state,
        globalSearchLP: {},
      };
    case types.LP_INCLUDED_WITH_SUBSCRIPTION_RESPONSE:
      return {
        ...state,
        lpsIncludedWithSubscription: action.payload,
      };
    case types.LP_INCLUDED_WITH_SUBSCRIPTION_CLEAR:
      return {
        ...state,
        lpsIncludedWithSubscription: {},
      };
      case types.GET_SURVEY_RESP:
        return {
          ...state,
          surveyListing: action.payload,
        };
      case types.GET_SURVEY_CLEAR:
        return {
          ...state,
          surveyListing: {},
        };
        case types.SHOW_SURVEY_RESP:
        return {
          ...state,
          showSurveyListing: action.payload,
        };
      case types.SHOW_SURVEY_CLEAR:
        return {
          ...state,
          showSurveyListing: {},
        };
        case types.SUBMIT_SURVEY_RESP:
          return {
            ...state,
            submitSurveyListing: action.payload,
          };
        case types.SUBMIT_SURVEY_CLEAR:
          return {
            ...state,
            submitSurveyListing: {},
          };
          case types.SHOW_TEMPLATE_RESP:
            return {
              ...state,
              templateListing: action.payload,
            };
          case types.SHOW_TEMPLATE_CLEAR:
            return {
              ...state,
              templateListing: {},
            };
    default:
      return state;
  }
};

export default lp;
